export const OPEN_DRAWER = "OPEN_DRAWER";
export const CLOSE_DRAWER = "CLOSE_DRAWER";

export const USER_LOGIN_LOADING = "USER_LOGIN_LOADING";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_ERROR = "USER_LOGIN_ERROR";

export const CREATE_LEAGUE_LOADING = "CREATE_LEAGUE_LOADING";
export const CREATE_LEAGUE_SUCCESS = "CREATE_LEAGUE_SUCCESS";
export const CREATE_LEAGUE_ERROR = "CREATE_LEAGUE_ERROR";
export const EDIT_LEAGUE_LOADING = "EDIT_LEAGUE_LOADING";
export const EDIT_LEAGUE_SUCCESS = "EDIT_LEAGUE_SUCCESS";
export const EDIT_LEAGUE_ERROR = "EDIT_LEAGUE_ERROR";
export const DELETE_LEAGUE_LOADING = "DELETE_LEAGUE_LOADING";
export const DELETE_LEAGUE_ERROR = "DELETE_LEAGUE_ERROR";
export const DELETE_LEAGUE_SUCCESS = "DELETE_LEAGUE_SUCCESS";

export const SEASONS_LIST_LOADING = "SEASONS_LIST_LOADING";
export const SEASONS_LIST_SUCCESS = "SEASONS_LIST_SUCCESS";
export const SEASONS_LIST_ERROR = "SEASONS_LIST_ERROR";

export const LIST_LEAGUES_LOADING = "LIST_LEAGUES_LOADING";
export const LIST_LEAGUES_SUCCESS = "LIST_LEAGUES_SUCCESS";
export const LIST_LEAGUES_ERROR = "LIST_LEAGUES_ERROR";

export const LIST_POINT_SYSTEM_LOADING = "LIST_POINT_SYSTEM_LOADING";
export const LIST_POINT_SYSTEM_SUCCESS = "LIST_POINT_SYSTEM_SUCCESS";
export const LIST_POINT_SYSTEM_ERROR = "LIST_POINT_SYSTEM_ERROR";
export const UPDATE_POINT_SYSTEM_LOADING = "UPDATE_POINT_SYSTEM_LOADING";
export const UPDATE_POINT_SYSTEM_SUCCESS = "UPDATE_POINT_SYSTEM_SUCCESS";
export const UPDATE_POINT_SYSTEM_ERROR = "UPDATE_POINT_SYSTEM_ERROR";

export const ADD_POINT_SYSTEM_LOADING = "ADD_POINT_SYSTEM_LOADING";
export const ADD_POINT_SYSTEM_SUCCESS = "ADD_POINT_SYSTEM_SUCCESS";
export const ADD_POINT_SYSTEM_ERROR = "ADD_POINT_SYSTEM_ERROR";
export const GET_SEASON_LOADING = "GET_SEASON_LOADING";
export const GET_SEASON_SUCCESS = "GET_SEASON_SUCCESS";
export const GET_SEASON_ERROR = "GET_SEASON_ERROR";

export const GET_SCORES_LOADING = "GET_SCORES_LOADING";
export const GET_SCORES_SUCCESS = "GET_SCORES_SUCCESS";
export const GET_SCORES_ERROR = "GET_SCORES_ERROR";

export const SUBMIT_SCORES_LOADING = "SUBMIT_SCORES_LOADING";
export const SUBMIT_SCORES_SUCCESS = "SUBMIT_SCORES_SUCCESS";
export const SUBMIT_SCORES_ERROR = "SUBMIT_SCORES_ERROR";

// --------------------------- Courses Module
export const GET_COURSES_LOADING = "GET_COURSES_LOADING";
export const GET_COURSES_SUCCESS = "GET_COURSES_SUCCESS";
export const GET_COURSES_ERROR = "GET_COURSES_SUCCESS";

export const GET_MIN_COURSES_LOADING = "GET_MIN_COURSES_LOADING";
export const GET_MIN_COURSES_SUCCESS = "GET_MIN_COURSES_SUCCESS";
export const GET_MIN_COURSES_ERROR = "GET_MIN_COURSES_SUCCESS";

export const VIEW_COURSE_LOADING = "VIEW_COURSE_LOADING";
export const VIEW_COURSE_SUCCESS = "VIEW_COURSE_SUCCESS";
export const VIEW_COURSE_ERROR = "VIEW_COURSE_ERROR";

export const CREATE_COURSES_LOADING = "CREATE_COURSES_LOADING";
export const CREATE_COURSES_SUCCESS = "CREATE_COURSES_SUCCESS";
export const CREATE_COURSES_ERROR = "CREATE_COURSES_ERROR";

export const DELETE_COURSES_LOADING = "DELETE_COURSES_LOADING";
export const DELETE_COURSES_SUCCESS = "DELETE_COURSES_SUCCESS";
export const DELETE_COURSES_ERROR = "DELETE_COURSES_ERROR";

export const EDIT_COURSES_LOADING = "EDIT_COURSES_LOADING";
export const EDIT_COURSES_SUCCESS = "EDIT_COURSES_SUCCESS";
export const EDIT_COURSES_ERROR = "EDIT_COURSES_ERROR";

// --------------------------- Sponsors Module
export const GET_SPONSORS_LOADING = "GET_SPONSORS_LOADING";
export const GET_SPONSORS_SUCCESS = "GET_SPONSORS_SUCCESS";
export const GET_SPONSORS_ERROR = "GET_SPONSORS_ERROR";

export const CREATE_SPONSORS_LOADING = "CREATE_SPONSORS_LOADING";
export const CREATE_SPONSORS_SUCCESS = "CREATE_SPONSORS_SUCCESS";
export const CREATE_SPONSORS_ERROR = "CREATE_SPONSORS_ERROR";

export const DELETE_SPONSORS_LOADING = "DELETE_SPONSORS_LOADING";
export const DELETE_SPONSORS_SUCCESS = "DELETE_SPONSORS_SUCCESS";
export const DELETE_SPONSORS_ERROR = "DELETE_SPONSORS_ERROR";

export const EDIT_SPONSORS_LOADING = "EDIT_SPONSORS_LOADING";
export const EDIT_SPONSORS_SUCCESS = "EDIT_SPONSORS_SUCCESS";
export const EDIT_SPONSORS_ERROR = "EDIT_SPONSORS_ERROR";

// --------------------------- News Module
export const GET_NEWS_LOADING = "GET_NEWS_LOADING";
export const GET_NEWS_SUCCESS = "GET_NEWS_SUCCESS";
export const GET_NEWS_ERROR = "GET_NEWS_ERROR";

export const CREATE_NEWS_LOADING = "CREATE_NEWS_LOADING";
export const CREATE_NEWS_SUCCESS = "CREATE_NEWS_SUCCESS";
export const CREATE_NEWS_ERROR = "CREATE_NEWS_ERROR";

export const DELETE_NEWS_LOADING = "DELETE_NEWS_LOADING";
export const DELETE_NEWS_SUCCESS = "DELETE_NEWS_SUCCESS";
export const DELETE_NEWS_ERROR = "DELETE_NEWS_ERROR";

export const EDIT_NEWS_LOADING = "EDIT_NEWS_LOADING";
export const EDIT_NEWS_SUCCESS = "EDIT_NEWS_SUCCESS";
export const EDIT_NEWS_ERROR = "EDIT_NEWS_ERROR";

// --------------------------- Announcements Module
export const GET_ANNOUNCEMENTS_LOADING = "GET_ANNOUNCEMENTS_LOADING";
export const GET_ANNOUNCEMENTS_SUCCESS = "GET_ANNOUNCEMENTS_SUCCESS";
export const GET_ANNOUNCEMENTS_ERROR = "GET_ANNOUNCEMENTS_ERROR";

export const CREATE_ANNOUNCEMENTS_LOADING = "CREATE_ANNOUNCEMENTS_LOADING";
export const CREATE_ANNOUNCEMENTS_SUCCESS = "CREATE_ANNOUNCEMENTS_SUCCESS";
export const CREATE_ANNOUNCEMENTS_ERROR = "CREATE_ANNOUNCEMENTS_ERROR";

export const DELETE_ANNOUNCEMENTS_LOADING = "DELETE_ANNOUNCEMENTS_LOADING";
export const DELETE_ANNOUNCEMENTS_SUCCESS = "DELETE_ANNOUNCEMENTS_SUCCESS";
export const DELETE_ANNOUNCEMENTS_ERROR = "DELETE_ANNOUNCEMENTS_ERROR";

// Tournament Module

export const TOURNAMENTS_LIST_LOADING = "TOURNAMENTS_LIST_LOADING";
export const TOURNAMENTS_LIST_SUCCESS = "TOURNAMENTS_LIST_SUCCESS";
export const TOURNAMENTS_LIST_ERROR = "TOURNAMENTS_LIST_ERROR";

export const GET_A_TOURNAMENT_LIST_LOADING = "GET_A_TOURNAMENT_LIST_LOADING";
export const GET_A_TOURNAMENT_LIST_SUCCESS = "GET_A_TOURNAMENT_LIST_SUCCESS";
export const GET_A_TOURNAMENT_LIST_ERROR = "GET_A_TOURNAMENT_LIST_ERROR";

export const CREATE_TOURNAMENT_LOADING = "CREATE_TOURNAMENT_LOADING";
export const CREATE_TOURNAMENT_SUCCESS = "CREATE_TOURNAMENT_SUCCESS";
export const CREATE_TOURNAMENT_ERROR = "CREATE_TOURNAMENT_ERROR";

export const GET_ONE_TOURNAMENT_LOADING = "GET_ONE_TOURNAMENT_LOADING";
export const GET_ONE_TOURNAMENT_SUCCESS = "GET_ONE_TOURNAMENT_SUCCESS";
export const GET_ONE_TOURNAMENT_ERROR = "GET_ONE_TOURNAMENT_ERROR";
export const CLEAR_TOURNMENT_DATA = "CLEAR_TOURNMENT_DATA";

export const UPDATE_PLAYER_STATUS_LOADING = "UPDATE_PLAYER_STATUS_LOADING";
export const UPDATE_PLAYER_STATUS_SUCCESS = "UPDATE_PLAYER_STATUS_SUCCESS";
export const UPDATE_PLAYER_STATUS_ERROR = "UPDATE_PLAYER_STATUS_ERROR";

export const CREATE_DRAW_LOADING = "CREATE_DRAW_LOADING";
export const CREATE_DRAW_SUCCESS = "CREATE_DRAW_SUCCESS";
export const CREATE_DRAW_ERROR = "CREATE_DRAW_ERROR";

export const EDIT_ANNOUNCEMENTS_LOADING = "EDIT_ANNOUNCEMENTS_LOADING";
export const EDIT_ANNOUNCEMENTS_SUCCESS = "EDIT_ANNOUNCEMENTS_SUCCESS";
export const EDIT_ANNOUNCEMENTS_ERROR = "EDIT_ANNOUNCEMENTS_ERROR";

// --------------------------- Dashboard Module

export const GET_DASHBOARD_NEWS_LOADING = "GET_DASHBOARD_NEWS_LOADING";
export const GET_DASHBOARD_NEWS_SUCCESS = "GET_DASHBOARD_NEWS_SUCCESS";
export const GET_DASHBOARD_NEWS_ERROR = "GET_DASHBOARD_NEWS_ERROR";

export const GET_DASHBOARD_ANNOUNCEMENT_LOADING =
  "GET_DASHBOARD_ANNOUNCEMENT_LOADING";
export const GET_DASHBOARD_ANNOUNCEMENT_SUCCESS =
  "GET_DASHBOARD_ANNOUNCEMENT_SUCCESS";
export const GET_DASHBOARD_ANNOUNCEMENT_ERROR =
  "GET_DASHBOARD_ANNOUNCEMENT_ERROR";

export const GET_DASHBOARD_CALENDER_LOADING = "GET_DASHBOARD_CALENDER_LOADING";
export const GET_DASHBOARD_CALENDER_SUCCESS = "GET_DASHBOARD_CALENDER_SUCCESS";
export const GET_DASHBOARD_CALENDER_ERROR = "GET_DASHBOARD_CALENDER_ERROR";

export const GET_DASHBOARD_PLAYER_DETAILS_LOADING =
  "GET_DASHBOARD_PLAYER_DETAILS_LOADING";
export const GET_DASHBOARD_PLAYER_DETAILS_SUCCESS =
  "GET_DASHBOARD_PLAYER_DETAILS_SUCCESS";
export const GET_DASHBOARD_PLAYER_DETAILS_ERROR =
  "GET_DASHBOARD_PLAYER_DETAILS_ERROR";

export const USER_ROLE = "USER_ROLE";

export const GET_DASHBOARD_SPONSORS_LOADING = "GET_DASHBOARD_SPONSORS_LOADING";
export const GET_DASHBOARD_SPONSORS_SUCCESS = "GET_DASHBOARD_SPONSORS_SUCCESS";
export const GET_DASHBOARD_SPONSORS_ERROR = "GET_DASHBOARD_SPONSORS_ERROR";

export const GET_DASHBOARD_EVENTS_LOADING = "GET_DASHBOARD_EVENTS_LOADING";
export const GET_DASHBOARD_EVENTS_SUCCESS = "GET_DASHBOARD_EVENTS_SUCCESS";
export const GET_DASHBOARD_EVENTS_ERROR = "GET_DASHBOARD_EVENTS_ERROR";

export const GET_DASHBOARD_LATEST_TOURNMENT_LOADING =
  "GET_DASHBOARD_LATEST_TOURNMENT_LOADING";
export const GET_DASHBOARD_LATEST_TOURNMENT_SUCCESS =
  "GET_DASHBOARD_LATEST_TOURNMENT_SUCCESS";
export const GET_DASHBOARD_LATEST_TOURNMENT_ERROR =
  "GET_DASHBOARD_LATEST_TOURNMENT_ERROR";

export const GET_DASHBOARD_COMBINE_LEADERBOARD_LOADING =
  "GET_DASHBOARD_COMBINE_LEADERBOARD_LOADING";
export const GET_DASHBOARD_COMBINE_LEADERBOARD_SUCCESS =
  "GET_DASHBOARD_COMBINE_LEADERBOARD_SUCCESS";
export const GET_DASHBOARD_COMBINE_LEADERBOARD_FAIL =
  "GET_DASHBOARD_COMBINE_LEADERBOARD_FAIL";

// --------------------------- Players Area Module
export const GET_PLAYERS_LOADING = "GET_PLAYERS_LOADING";
export const GET_PLAYERS_SUCCESS = "GET_PLAYERS_SUCCESS";
export const GET_PLAYERS_ERROR = "GET_PLAYERS_ERROR";

export const CREATE_PLAYERS_LOADING = "CREATE_PLAYERS_LOADING";
export const CREATE_PLAYERS_SUCCESS = "CREATE_PLAYERS_SUCCESS";
export const CREATE_PLAYERS_ERROR = "CREATE_PLAYERS_ERROR";

export const EDIT_PLAYERS_LOADING = "EDIT_PLAYERS_LOADING";
export const EDIT_PLAYERS_SUCCESS = "EDIT_PLAYERS_SUCCESS";
export const EDIT_PLAYERS_ERROR = "EDIT_PLAYERS_ERROR";

export const DELETE_PLAYERS_LOADING = "DELETE_PLAYERS_LOADING";
export const DELETE_PLAYERS_SUCCESS = "DELETE_PLAYERS_SUCCESS";
export const DELETE_PLAYERS_ERROR = "DELETE_PLAYERS_ERROR";

export const GET_PLAYER_SCORE_LOADING = "GET_PLAYER_SCORE_LOADING";
export const GET_PLAYER_SCORE_SUCCESS = "GET_PLAYER_SCORE_SUCCESS";
export const GET_PLAYER_SCORE_ERROR = "GET_PLAYER_SCORE_ERROR";

export const GET_FRONTBACKCOURSES_LOADING = "GET_FRONTBACKCOURSES_LOADING";
export const GET_FRONTBACKCOURSES_SUCCESS = "GET_FRONTBACKCOURSES_SUCCESS";
export const GET_FRONTBACKCOURSES_ERROR = "GET_FRONTBACKCOURSES_ERROR";

export const SEND_DRAWS_LOADING = "";
export const SEND_DRAWS_SUCCESS = "";
export const SEND_DRAWS_ERROR = "";

export const GET_MINIMAL_PLAYERS_LOADING = "GET_MINIMAL_PLAYERS_LOADING";
export const GET_MINIMAL_PLAYERS_SUCCESS = "GET_MINIMAL_PLAYERS_SUCCESS";
export const GET_MINIMAL_PLAYERS_ERROR = "GET_MINIMAL_PLAYERS_ERROR";

// --------------------------- DMP Module

export const CREATE_DMPLIST_SUCCESS = "CREATE_DMPLIST_SUCCESS";
export const CREATE_DMP_EMPTYARRAY = "CREATE_DMP_EMPTYARRAY";

export const GET_DMPLIST_LOADING = "GET_DMPLIST_LOADING";
export const GET_DMPLIST_SUCCESS = "GET_DMPLIST_SUCCESS";
export const GET_DMPLIST_ERROR = "GET_DMPLIST_ERROR";
export const CLEAR_DMP_LIST = "CLEAR_DMP_LIST";

export const GET_COURSE_INDEX_PAR_LOADING = "GET_COURSE_INDEX_PAR_LOADING";
export const GET_COURSE_INDEX_PAR_SUCCESS = "GET_COURSE_INDEX_PAR";
export const GET_COURSE_INDEX_PAR_ERROR = "GET_COURSE_INDEX_PAR_ERROR";
export const CLEAR_COURSE_INDEX_PAR = "GET_COURSE_INDEX_PAR_ERROR";

// ---------------------------- League Players
export const GET_LEAGUEPLAYERS_LOADING = "GET_LEAGUEPLAYERS_LOADING";
export const GET_LEAGUEPLAYERS_SUCCESS = "GET_LEAGUEPLAYERS_SUCCESS";
export const GET_LEAGUEPLAYERS_ERROR = "GET_LEAGUEPLAYERS_ERROR";

export const ADD_PLAYERS_LOADING = "ADD_PLAYERS_LOADING";
export const ADD_PLAYERS_ERROR = "ADD_PLAYERS_ERROR";
export const ADD_PLAYERS_SUCCESS = "ADD_PLAYERS_SUCCESS";

export const ADD_DMPPLAYERS_SUCCESS = "ADD_DMPPLAYERS_SUCCESS";
export const ADD_DMPPLAYERS_ERROR = "ADD_DMPPLAYERS_ERROR";
export const ADD_DMPPLAYERS_LOADING = "ADD_DMPPLAYERS_LOADING";
export const CLEAR_DMPPLAYERS = "CLEAR_DMPPLAYERS";

// Leaderboard contants

export const GET_LEADERBOARD_LOADING = "GET_LEADERBOARD_LOADING";
export const GET_LEADERBOARD_SUCCESS = "GET_LEADERBOARD_SUCCESS";
export const GET_LEADERBOARD_ERROR = "GET_LEADERBOARD_ERROR";
export const CLEAR_LEADERBOARD_DATA = "CLEAR_LEADERBOARD_DATA";

export const GET_POTY_TOURNAMENT_SEASON_LOADING =
  "GET_POTY_TOURNAMENT_SEASON_LOADING";
export const GET_POTY_TOURNAMENT_SEASON_SUCCESS =
  "GET_POTY_TOURNAMENT_SEASON_SUCCESS";
export const GET_POTY_TOURNAMENT_SEASON_ERROR =
  "GET_POTY_TOURNAMENT_SEASON_ERROR";

export const CREATE_ADDSCRORECARD_LOADING = "CREATE_ADDSCRORECARD_LOADING";
export const CREATE_ADDSCRORECARD_SUCCESS = "CREATE_ADDSCRORECARD_SUCCESS";
export const CREATE_ADDSCRORECARD_ERROR = "CREATE_ADDSCRORECARD_ERROR";

// SMP
export const GET_LATEST_LEAGUE_SMP_LOADING = "GET_LATEST_LEAGUE_SMP_LOADING";
export const GET_LATEST_LEAGUE_SMP_ERROR = "GET_LATEST_LEAGUE_SMP_ERROR";
export const GET_LATEST_LEAGUE_SMP_SUCCESS = "GET_LATEST_LEAGUE_SMP_SUCCESS";

export const CREATE_SMP_LIST_LOADING = "CREATE_SMP_LIST_LOADING";
export const CREATE_SMP_LIST_SUCCESS = "CREATE_SMP_LIST_SUCCESS";
export const CREATE_SMP_LIST_ERROR = "CREATE_SMP_LIST_ERROR";
export const CLEAR_SMP_LIST = "CLEAR_SMP_LIST";

export const GET_GROUPS_AND_TEES_LOADING = "GET_GROUPS_AND_TEES_LOADING";
export const GET_GROUPS_AND_TEES_ERROR = "GET_GROUPS_AND_TEES_ERROR";
export const GET_GROUPS_AND_TEES_SUCCESS = "GET_GROUPS_AND_TEES_SUCCESS";

export const HOLES_INDEX_PAR_LOADING = "HOLES_INDEX_PAR_LOADING";
export const HOLES_INDEX_PAR_SUCCESS = "HOLES_INDEX_PAR_SUCCESS";
export const HOLES_INDEX_PAR_ERROR = "HOLES_INDEX_PAR_ERROR";
export const CLEAR_HOLES_INDEX_PAR = "CLEAR_HOLES_INDEX_PAR";

export const SUBMIT_SCORE_LOADING = "SUBMIT_SCORE_LOADING";
export const SUBMIT_SCORE_ERROR = "SUBMIT_SCORE_ERROR";
export const SUBMIT_SCORE_SUCCESS = "SUBMIT_SCORE_SUCCESS";
export const CLEAR_SUBMIT_SCORE = "CLEAR_SUBMIT_SCORE";

export const GET_SCORE_LOADING = "GET_SCORE_LOADING";
export const GET_SCORE_ERROR = "GET_SCORE_ERROR";
export const GET_SCORE_SUCCESS = "GET_SCORE_SUCCESS";
export const CLEAR_SCORE = "CLEAR_SCORE";

export const GET_SMP_LIST_LOADING = "GET_SMP_LIST_LOADING";
export const GET_SMP_LIST_ERROR = "GET_SMP_LIST_ERROR";
export const GET_SMP_LIST_SUCCESS = "GET_SMP_LIST_SUCCESS";

export const GET_SELECTED_LEAGUE_LOADING = "GET_SELECTED_LEAGUE_LOADING";
export const GET_SELECTED_LEAGUE_ERROR = "GET_SELECTED_LEAGUE_ERROR";
export const GET_SELECTED_LEAGUE_SUCCESS = "GET_SELECTED_LEAGUE_SUCCESS";

export const GET_SELECTED_DMP_LEAGUE_LOADING =
  "GET_SELECTED_DMP_LEAGUE_LOADING";
export const GET_SELECTED_DMP_LEAGUE_ERROR = "GET_SELECTED_DMP_LEAGUE_ERROR";
export const GET_SELECTED_DMP_LEAGUE_ID = "GET_SELECTED_DMP_LEAGUE_ID";
export const GET_SELECTED_DMP_LEAGUE_SUCCESS =
  "GET_SELECTED_DMP_LEAGUE_SUCCESS";
export const CLEAR_SELECTED_DMP_LEAGUE = "CLEAR_SELECTED_DMP_LEAGUE";
export const CLEAR_SELECTED_DMP_LEAGUE_ID = "CLEAR_SELECTED_DMP_LEAGUE_ID";

export const CLEAR_DELETE_LEAGUE = "CLEAR_DELETE_LEAGUE";
export const CLEAR_CREATE_LEAGUE = "CLEAR_CREATE_LEAGUE";
export const CLEAR_EDIT_LEAGUE = "CLEAR_EDIT_LEAGUE";

// Team Module
export const GET_TEAMS_LOADING = "GET_TEAMS_LOADING";
export const GET_TEAMS_SUCCESS = "GET_TEAMS_SUCCESS";
export const GET_TEAMS_ERROR = "GET_TEAMS_ERROR";

// Team Ranking Module
export const GET_TEAM_RANKING_LOADING = "GET_TEAM_RANKING_LOADING";
export const GET_TEAM_RANKING_SUCCESS = "GET_TEAM_RANKING_SUCCESS";
export const GET_TEAM_RANKING_ERROR = "GET_TEAM_RANKING_ERROR";

export const GET_MIN_TEAMS_LOADING = "GET_MIN_TEAMS_LOADING";
export const GET_MIN_TEAMS_SUCCESS = "GET_MIN_TEAMS_SUCCESS";
export const GET_MIN_TEAMS_ERROR = "GET_MIN_TEAMS_SUCCESS";

export const VIEW_TEAM_LOADING = "VIEW_TEAM_LOADING";
export const VIEW_TEAM_SUCCESS = "VIEW_TEAM_SUCCESS";
export const VIEW_TEAM_ERROR = "VIEW_TEAM_ERROR";

export const CREATE_TEAMS_LOADING = "CREATE_TEAMS_LOADING";
export const CREATE_TEAMS_SUCCESS = "CREATE_TEAMS_SUCCESS";
export const CREATE_TEAMS_ERROR = "CREATE_TEAMS_ERROR";

export const DELETE_TEAMS_LOADING = "DELETE_TEAMS_LOADING";
export const DELETE_TEAMS_SUCCESS = "DELETE_TEAMS_SUCCESS";
export const DELETE_TEAMS_ERROR = "DELETE_TEAMS_ERROR";

export const EDIT_TEAMS_LOADING = "EDIT_TEAMS_LOADING";
export const EDIT_TEAMS_SUCCESS = "EDIT_TEAMS_SUCCESS";
export const EDIT_TEAMS_ERROR = "EDIT_TEAMS_ERROR";